import React from 'react';
import PropTypes from 'prop-types';

import { MENU_TYPES } from 'dpl/decorators/withMobileMenu';
import MobileMenu from 'dpl/components/MobileMenu';

/** @param {any} props */
export default function MobileNavigationMenu({
  openMobileMenuName = null,
  links
}) {
  const isOpen = openMobileMenuName === MENU_TYPES.NAVIGATION;

  return (
    <MobileMenu
      className="MobileNavigationMenu"
      isOpen={isOpen}
      position="top"
      zIndex="99999"
    >
      <nav className="ph5 pb5">
        <ul>
          {links.map(
            (
              { href: linkHref, title: linkTitle, onClick: linkAction },
              idx
            ) => (
              <li key={idx}>
                {linkHref ? (
                  <a
                    className="pv5 bb b--black-10 db flex items-center fw-medium"
                    href={linkHref}
                  >
                    {linkTitle}
                  </a>
                ) : (
                  <button
                    className="pv5 bb b--black-10 db flex items-center fw-medium w-100"
                    onClick={linkAction}
                    type="button"
                  >
                    {linkTitle}
                  </button>
                )}
              </li>
            )
          )}
        </ul>
      </nav>
    </MobileMenu>
  );
}

MobileNavigationMenu.propTypes = {
  openMobileMenuName: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      onClick: PropTypes.func,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
